import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface RelatorioExtratoDialogProps {
  open: boolean;
  loading: boolean;
  /** Dispara a geração; `imprimeEspelho` = Com aba de Espelhos. */
  onChoose: (imprimeEspelho: boolean) => void;
  onClose: () => void;
}

/**
 * Caixa "Tipo de Impressão" — espelha o WW `EmpresaNotaFiscalWW`: pergunta se o
 * Excel sai com ou sem aba de espelhos antes de gerar o extrato mensal.
 */
export function RelatorioExtratoDialog({
  open,
  loading,
  onChoose,
  onClose,
}: RelatorioExtratoDialogProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t('features.empresa.notasFiscais.relatorioExtrato.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('features.empresa.notasFiscais.relatorioExtrato.subtitle')}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ width: '100%' }}>
          <Button
            variant="contained"
            fullWidth
            disabled={loading}
            startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
            onClick={() => onChoose(true)}
          >
            {t('features.empresa.notasFiscais.relatorioExtrato.comEspelho')}
          </Button>
          <Button variant="outlined" fullWidth disabled={loading} onClick={() => onChoose(false)}>
            {t('features.empresa.notasFiscais.relatorioExtrato.semEspelho')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
